import type { BookingFactCreateInput, ConsultationId, CustomerId } from '@gh/common/models'
import { writeBookingFact } from '@/components/consultation/bookingFacts/bookingFactsWriter'

export type ClinicalBookingFactsWriteContext = {
  consultationId: ConsultationId
  customerId: CustomerId
}

type PendingClinicalBookingFact = Omit<
  BookingFactCreateInput,
  'id' | 'consultationId' | 'customerId'
>

let activeContext: ClinicalBookingFactsWriteContext | null = null
const pendingFacts: PendingClinicalBookingFact[] = []

export function enqueueClinicalBookingFact(fact: PendingClinicalBookingFact): void {
  pendingFacts.push(fact)
}

function flushPendingClinicalBookingFacts(): void {
  if (!activeContext) {
    return
  }
  const { consultationId, customerId } = activeContext
  while (pendingFacts.length > 0) {
    const fact = pendingFacts.shift()
    if (fact) {
      void writeBookingFact({ consultationId, customerId, fact })
    }
  }
}

export function setClinicalBookingFactsWriteContext(
  context: ClinicalBookingFactsWriteContext | null,
): void {
  activeContext = context
  if (context) {
    flushPendingClinicalBookingFacts()
  }
}

export function getClinicalBookingFactsWriteContext(): ClinicalBookingFactsWriteContext | null {
  return activeContext
}
